import React from 'react';
import { StyleSheet, Text, View } from 'react-native';
import { GlassCard } from '@/components/shared/redesign/GlassCard';
import { useThemeColors } from '@/hooks/residents/useThemeColors';
import { REDESIGN_SPACING, REDESIGN_TYPOGRAPHY } from '@/constants/residents/homeConstants';

interface Props {
  hasResponded: boolean;
}

/**
 * Shown to residents after they submit a survey (or when they reopen one they
 * already answered, or a closed survey). Residents never see aggregate analysis
 * — that is admin-only.
 */
export const SurveyConfirmationView: React.FC<Props> = ({ hasResponded }) => {
  const { colors } = useThemeColors();

  const title = hasResponded ? 'Thanks for responding' : 'This survey has closed';
  const subtitle = hasResponded
    ? 'Your response has been recorded.'
    : 'This survey is no longer accepting responses.';

  return (
    <View style={styles.container}>
      <GlassCard
        variant="soft"
        borderRadius={REDESIGN_SPACING.cardBorderRadius}
        padding={REDESIGN_SPACING.cardPadding}
      >
        <Text
          style={[
            REDESIGN_TYPOGRAPHY.cardTitle,
            { color: colors.text.primary, marginBottom: 6 },
          ]}
        >
          {title}
        </Text>
        <Text style={[REDESIGN_TYPOGRAPHY.body, { color: colors.text.secondary }]}>
          {subtitle}
        </Text>
      </GlassCard>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    paddingVertical: REDESIGN_SPACING.horizontalPadding,
  },
});
